import { browserOrDesktop } from '../utils/browserOrDesktop';
import * as browser from './rxAlert.web.browser';
import * as desktop from './rxAlert.web.desktop';

export const rxAlert = browserOrDesktop(browser.rxAlert, desktop.rxAlert);
